$('#login-popup [href="#login"]').click(e => {
  e.preventDefault()
  $('#login-popup [name=hash]').val(window.location.hash)
  $('#login-popup [type=submit]').click()
})
